module.exports = __webpack_public_path__ + "img/lms-drivebuzz.eb58eb37.png";